/**
 * Almost the same as lodash implementation, with cancel() functionality
 *
 * @param callback {function} - wrapped function
 * @param time {number} - ms to debounce the function
 * @param interval {number} - timer id
 * @return {function}
 */
const debounce = function (callback, time = 250, interval) {
  const cancel = () => clearTimeout(interval);
  const debounced = function (...args) {
    clearTimeout(interval);
    interval = setTimeout(() => callback(...args), time);
  };
  debounced.cancel = cancel;

  return debounced;
};

export default debounce;
